import { render, staticRenderFns } from "./aboutAuthor.vue?vue&type=template&id=34c88d95&scoped=true"
import script from "./aboutAuthor.vue?vue&type=script&lang=js"
export * from "./aboutAuthor.vue?vue&type=script&lang=js"
import style0 from "./aboutAuthor.vue?vue&type=style&index=0&id=34c88d95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c88d95",
  null
  
)

export default component.exports